import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA: register the service worker so the app becomes installable ("Add to
// Home Screen") on iOS Safari and Chrome/Edge on Android. The SW only caches
// static assets — /api requests always hit the network.
if ("serviceWorker" in navigator && window.location.protocol === "https:") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Auto-update safety net: check for a new SW every time the page
        // becomes visible again (e.g. user swaps back from another app),
        // and on load. When a new SW installs itself, it calls skipWaiting()
        // and clients.claim() so the new version takes over immediately.
        //
        // This is what closes the "I redeployed but users still see the
        // old JS" gap. Without this, a returning PWA user could see the
        // old code for hours (or until they force-quit the app).
        const checkForUpdate = () => reg.update().catch(() => {});
        checkForUpdate();
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") checkForUpdate();
        });
        // When a new SW takes control mid-session, reload once so the UI
        // matches the freshly-fetched JS bundle. controllerchange fires
        // exactly once per activation.
        let reloadedOnce = false;
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (reloadedOnce) return;
          reloadedOnce = true;
          window.location.reload();
        });
      })
      .catch(() => { /* Silent-fail: PWA install stays optional. */ });
  });
}
